import {
  COURSE_TITLE_CHANGED,
  COURSE_SUBJECT_CHANGED,
  COURSE_NUMBER_CHANGED,
  COURSE_UNIVERSITY_CHANGED,
  CLEAR_COURSE_FIELDS,
} from './action_types';

export const courseTitleChanged = text => ({ type: COURSE_TITLE_CHANGED, payload: text });
export const courseSubjectChanged = text => ({ type: COURSE_SUBJECT_CHANGED, payload: text });
export const courseNumberChanged = text => ({ type: COURSE_NUMBER_CHANGED, payload: text });
export const courseUniversityChanged = _id => ({ type: COURSE_UNIVERSITY_CHANGED, payload: _id });
export const clearCourseFields = text => ({ type: CLEAR_COURSE_FIELDS, payload: text });



// WEBPACK FOOTER //
// ./src/modules/courses/components/AddCourse/actions.js